import {Component} from '@angular/core';
import {DecimalPipe} from "@angular/common";
import {NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {Page} from "../../../../../generated-model/model";
import {ReactiveFormsModule} from "@angular/forms";

@Component({
  selector: 'app-deceased-eligible-service',
  standalone: true,
  imports: [
    DecimalPipe,
    NgbPagination,
    ReactiveFormsModule
  ],
  templateUrl: './deceased-eligible-service.component.html',
  styleUrl: './deceased-eligible-service.component.scss'
})
export class DeceasedEligibleServiceComponent {
  pageData: Page<any> = {size: 10};

  search(page: number = 1) {

  }
}
